import { render, staticRenderFns } from "./rfid-audit.vue?vue&type=template&id=67333e64&"
import script from "./rfid-audit.vue?vue&type=script&lang=js&"
export * from "./rfid-audit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports